import {createRoot} from 'react-dom/client';
import App from './App';
import '@fontsource/instrument-sans/400.css';
import '@fontsource/instrument-sans/400-italic.css';
import '@fontsource/instrument-sans/500.css';
import '@fontsource/instrument-sans/600.css';
import '@fontsource/instrument-sans/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import './scss/style.scss';
import baseUrl from './api/baseUrl';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {BrowserRouter as Router} from 'react-router-dom';
import {AppSettingsProvider} from './hooks/useAppSettings';
import {AuthStateManagerProvider} from './hooks/useAuthStateManager';

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
    <Router>
        <AuthStateManagerProvider baseUri={baseUrl}>
            <QueryClientProvider client={queryClient}>
                <AppSettingsProvider>
                    <App />
                </AppSettingsProvider>
            </QueryClientProvider>
        </AuthStateManagerProvider>
    </Router>
);
